/**
 * Backend endpoints, built from the root domain the game was launched on.
 *
 * The launcher (`launcher.<domain>`) redirects to the frontend hosted on the same
 * root domain, so `<domain>` is taken from the page's own hostname
 * (`fruityjungle.yogames.win` → `yogames.win`) instead of being hardcoded — one
 * build then works on every operator domain. The API lives on
 * `slotgamesapi.<domain>`, the launcher on `launcher.<domain>`.
 *
 * `localhost` / IP addresses (local dev) fall back to `FALLBACK_DOMAIN`.
 * `?domain=example.com` overrides the domain for testing without a redeploy.
 */

const FALLBACK_DOMAIN = 'yogames.win';

function resolveRootDomain() {
  const override = new URLSearchParams(window.location.search).get('domain');
  if (override) return override.toLowerCase();

  const host = window.location.hostname.toLowerCase();
  const isIp = /^[\d.]+$/.test(host) || host.includes(':');
  const labels = host.split('.').filter(Boolean);
  if (isIp || labels.length < 2) return FALLBACK_DOMAIN;
  return labels.slice(-2).join('.');
}

export const ROOT_DOMAIN = resolveRootDomain();
export const API_ORIGIN = `https://slotgamesapi.${ROOT_DOMAIN}`;
export const LAUNCHER_ORIGIN = `https://launcher.${ROOT_DOMAIN}`;

console.log('[Endpoints] root domain:', ROOT_DOMAIN, '| api:', API_ORIGIN, '| launcher:', LAUNCHER_ORIGIN);
